<template>
  <div class="tooltip">
    <p :class="{ clamped: useTranslated }" v-html="displayDescription"></p>
    <span class="tooltiptext" v-html="displayDescription"></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useProductsContext } from "../../useProductsContext";
import type { IProductTableData } from "@/types/db/product-category";

type Props = {
  row: IProductTableData;
};

const props = defineProps<Props>();
const ctx = useProductsContext();

/**
 * Whether the description has a non-empty translated value. Only when true do
 * we clamp the description text — mirrors the legacy template's `class="clamped"`
 * being applied only on the translated branch.
 *
 * @returns {boolean}
 */
const useTranslated = computed((): boolean => {
  return ctx.getTranslationForProducts(props.row.descriptionLocale) !== "";
});

/**
 * Description string (HTML). Translated value when present, raw fallback otherwise.
 *
 * @returns {string}
 */
const displayDescription = computed((): string => {
  if (useTranslated.value) {
    return ctx.getTranslationForProducts(props.row.descriptionLocale);
  }

  return props.row.description;
});
</script>
